<app-loader [loading]="qsLoading" [fullPage]="true" [title]="'qs.title' | i18n"></app-loader>
<section [hidden]="qsLoading" class="simulation grid-container grid-container--section no-gutter-mobile ng-scope" data-overload-controller="AdhesionPegaseCtrl">
    <app-stepper-component [currentStepId]="'qs'"></app-stepper-component>

    <div>
        <form *ngIf="qsForm" [formGroup]="qsForm" (ngSubmit)="preValidateQs(qsForm)" enctype="multipart/form-data">
            <fieldset class="simulation__step" name="adhesionForm">
                <legend style="display: none">{{ 'qs.title' | i18n }}</legend>
                <!-- uiView: adhesionSteps -->
                <div data-ui-view="adhesionSteps" class="ng-scope">
                    <!-- uiView: medicalStep -->
                    <div cand-scroll-error="" class="grid-mobile-4 pull-mobile-0 no-gutter ng-scope grid-12" data-ng-class="medicalWorkflow.helpBlockVisible &amp;&amp; !isTablet() ? 'grid-8 pull-1' : 'grid-12'" data-ui-view="medicalStep">
                        <section
                            class="simulation__group simulation__group--qs simulation__group--qs-no-title ng-scope ng-valid-min ng-valid-max ng-invalid ng-invalid-required ng-dirty ng-valid-parse ng-valid-maxlength ng-valid-real-date ng-valid-pattern"
                            data-ng-form="qs.form"
                            data-overload-controller="QsPegaseCtrl"
                        >
                            <h1 class="page-title page-title--primary ng-binding">
                                {{ 'qs.title' | i18n }}
                            </h1>
                            <div class="grid-container warning">
                                <div class="grid-mobile-4">
                                    <p class="ng-binding">
                                        {{ 'qs.headerMessage' | i18n }}
                                    </p>
                                </div>
                            </div>
                            <div class="simulation__group">
                                <div class="simulation__content simulation__content--no-padding">
                                    <div class="grid-12 grid-mobile-4 no-gutter">
                                        <ol class="simulation__list simulation__group--qs-summary qs-summary-wrapper">
                                            <!-- ngRepeat: section in qs.questionnaireSections track by $index -->
                                            <li
                                                class="grid-container"
                                                *ngFor="let questionQuestionnaireSante of listeQuestionsEntete"
                                                [ngClass]="{
                                                    'list-digit': !questionQuestionnaireSante.questionChapeau,
                                                    'simulation__listItem--qs-summary': !questionQuestionnaireSante.questionChapeau
                                                }"
                                            >
                                                <app-question-taille-component *ngIf="questionQuestionnaireSante.questionTaille" [qsForm]="qsForm" [questionQuestionnaireSante]="questionQuestionnaireSante"> </app-question-taille-component>
                                                <app-question-motif-component
                                                    *ngIf="!questionQuestionnaireSante.questionTaille && !questionQuestionnaireSante.questionChapeau"
                                                    [qsForm]="qsForm"
                                                    [questionQuestionnaireSante]="questionQuestionnaireSante"
                                                >
                                                </app-question-motif-component>
                                                <app-question-chapeau-component
                                                    *ngIf="questionQuestionnaireSante.questionChapeau"
                                                    [qsForm]="qsForm"
                                                    [questionQuestionnaireSante]="questionQuestionnaireSante"
                                                    [allQuestions]="listeQuestionsQuestionnaireSante"
                                                >
                                                </app-question-chapeau-component>
                                            </li>

                                            <!-- end ngRepeat: section in qs.questionnaireSections track by $index -->
                                        </ol>
                                    </div>
                                </div>
                            </div>
                            <!-- ngIf: adhesion.creditProject.isH2Project -->
                            <div class="grid-container acceptance__option choice-box choice-box--inline-left acceptance ng-scope" data-ng-if="adhesion.creditProject.isH2Project">
                                <input
                                    [(ngModel)]="isSaveForNextAdhChecked"
                                    [ngModelOptions]="{ standalone: true }"
                                    id="saveDataAcceptance"
                                    class="choice ng-pristine ng-untouched ng-valid"
                                    type="checkbox"
                                    data-ng-model="adhesion.saveDataAcceptance"
                                />
                                <label class="choice-box__label acceptance-box__label" for="saveDataAcceptance" data-tag-commander="" [appTagCommander]="'tagCo.savadata.accept.checkbox'">
                                    <span class="ng-binding text-blue" [innerHTML]="'qs.checkbox.saveDataAcceptance' | i18n"></span>
                                </label>
                            </div>
                            <!-- end ngIf: adhesion.creditProject.isH2Project -->
                            <div class="qs-group">
                                <div class="qs__legal--notice ng-isolate-scope" data-append-to="qs.notice" [innerHTML]="'adhesion.qs.footer.legalNotice.1' | i18n"></div>
                                <div class="qs__legal--notice ng-isolate-scope" data-append-to="qs.notice" [innerHTML]="'adhesion.qs.footer.legalNotice.2' | i18n"></div>
                                <div class="qs__legal--notice ng-isolate-scope" data-append-to="qs.notice" [innerHTML]="'adhesion.qs.footer.legalNotice.3' | i18n"></div>
                                <div class="qs__legal--notice ng-isolate-scope" data-append-to="qs.notice" [innerHTML]="'adhesion.qs.footer.legalNotice.4' | i18n"></div>
                            </div>
                            <div class="pt-0 simulation__buttons simulation__buttons--light">
                                <div class="grid-4 grid-mobile-4 hide-mobile">
                                    <button id="qs-cancel" (click)="goBackToEspaceClientModal = true" data-tag-commander="" [appTagCommander]="'tagCo.qs.previous.button'" type="button" class="button--previous-cancel ng-binding">
                                      {{ 'global.button.cancel' | i18n }}
                                    </button>
                                  </div>
                                <div class="grid-4 grid-mobile-4 hide show-mobile no-gutter-mobile">
                                  <button
                                    id="qs-cancel-mobile"
                                    (click)="goBackToEspaceClientModal = true"
                                    data-tag-commander=""
                                    [appTagCommander]="'tagCo.qs.previous.button'"
                                    data-ng-click="qs.backToDashboard('backToDashboardFromQS')"
                                    type="button"
                                    class="pt-0 button--previous-cancel centered ng-binding"
                                  >
                                    {{ 'global.button.cancel' | i18n }}
                                  </button>
                                </div>
                                <div class="pt-0 simulation__buttons simulation__buttons--light flex-end">
                                <div class="grid-mobile-2 no-gutter-mobile">
                                    <button
                                        id="save-qs-responses"
                                        type="button"
                                        class="button button--download button--noBackground button-noBg button--primary button--save centered ng-binding ng-isolate-scope"
                                        [ngClass]="{
                                            'icon--loading': saveLoading
                                        }"
                                        data-api-call-button=""
                                        data-tag-commander=""
                                        [appTagCommander]="'tagCo.qs.save.button'"
                                        (click)="saveQs()"
                                    >
                                        {{ 'qs.button.save' | i18n }}
                                    </button>
                                </div>
                                <div class="grid-mobile-2 no-gutter-mobile">
                                    <button
                                        id="qs-validate"
                                        type="submit"
                                        class="button button--primary button--next float-right ng-binding ng-isolate-scope"
                                        data-api-call-button=""
                                        data-tag-commander=""
                                        [appTagCommander]="'tagCo.qs.validate.button'"
                                    >
                                        {{ 'qs.button.next' | i18n }}
                                    </button>
                                </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </fieldset>
        </form>
    </div>
</section>

<app-validation-modal-component
    [modalTitle]="'qs.save.title'"
    [content]="'qs.save.message'"
    [buttonLeft]="'qs.save.back'"
    [buttonRight]="'qs.save.resume'"
    [visibility]="showSuccesModal"
    (crossClick)="showSuccesModal = false"
    (leftClick)="navigateToEspaceClient()"
    (rightClick)="showSuccesModal = false"
></app-validation-modal-component>

<app-validation-modal-component
    [modalTitle]="'qs.save.back'"
    [content]="'adhesion.backToDashboard.modal.body'"
    [buttonLeft]="'global.no'"
    [buttonRight]="'global.yes'"
    [showInfoIcon]="false"
    [visibility]="goBackToEspaceClientModal"
    (crossClick)="goBackToEspaceClientModal = false"
    (leftClick)="goBackToEspaceClientModal = false"
    (rightClick)="navigateToEspaceClient()"
></app-validation-modal-component>

<app-validation-modal-component
    [modalTitle]="'qsstoqs.title'"
    [content]="'qsstoqs.message'"
    [buttonRight]="'qsstoqs.button'"
    [showLeftButton]="false"
    [visibility]="isFromQSS"
    (crossClick)="isFromQSS = false"
    (rightClick)="isFromQSS = false"
></app-validation-modal-component>

<app-validation-modal-component
    [modalTitle]="'adhesion.qs.validation.modal.title'"
    [content]="'adhesion.qs.validation.modal.question'"
    [buttonLeft]="'global.no'"
    [buttonRight]="'global.yes'"
    [showInfoIcon]="false"
    [visibility]="preValidateQsModal"
    (crossClick)="preValidateQsModal = false"
    (leftClick)="preValidateQsModal = false"
    (rightClick)="validateQs(qsForm); preValidateQsModal = false"
></app-validation-modal-component>

<app-steps-adhesion-modal [currentStepId]="'qs'"> </app-steps-adhesion-modal>
